import { render, staticRenderFns } from "./CreateAccountView.vue?vue&type=template&id=d0572a0c&scoped=true"
import script from "./CreateAccountView.vue?vue&type=script&lang=ts"
export * from "./CreateAccountView.vue?vue&type=script&lang=ts"
import style0 from "./CreateAccountView.vue?vue&type=style&index=0&id=d0572a0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0572a0c",
  null
  
)

export default component.exports